import { render, staticRenderFns } from "./MaterialTypeCheckboxes.vue?vue&type=template&id=3177425c&scoped=true"
import script from "./MaterialTypeCheckboxes.vue?vue&type=script&lang=js"
export * from "./MaterialTypeCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./MaterialTypeCheckboxes.vue?vue&type=style&index=0&id=3177425c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3177425c",
  null
  
)

export default component.exports